import { Component, Host, h, State, Listen, Prop, Fragment } from '@stencil/core';
import axios from '../../../utils/get-axios';

@Component({
  tag: 'lilu-disturber',
  styleUrl: 'lilu-disturber.scss',
  shadow: true,
})
export class LiluDisturber {
  @Prop() headline: string;
  @Prop() linktext: string;
  @Prop() linkhref: string;
  @Prop() backgroundcolor?: string;
  @Prop() textcolor?: string;
  @Prop() type: string;
  @State() isActive = true;
  @State() windowWidth: number;

  componentWillLoad() {
    this.windowWidth = window.outerWidth;
  }

  handleDisturber(e) {
    e.preventDefault();

    this.isActive = false;
    axios.get('/disturber/close');
  }

  renderBackgroundColor = () => {
    return { 'background-color': this.backgroundcolor };
  };

  renderTextColor = () => {
    return { color: this.textcolor };
  };

  @Listen('resize', { target: 'window' })
  resize() {
    this.windowWidth = window.outerWidth;
  }

  render() {
    const contentWishlist = (
      <div class="disturber wishlist" style={this.backgroundcolor ? this.renderBackgroundColor() : null}>
        <lilu-icon color="nero" type="icon-info"></lilu-icon>
        <div class="disturber-text-wrapper">
          <span class="headline" style={this.textcolor ? this.renderTextColor() : null}>
            {this.headline}
          </span>
          {this.linktext ? (
            <lilu-link appearance="underline" color="dark" colorcode={this.textcolor} link={this.linkhref} target="_self" size="size-14 lg-size-16">
              {this.linktext}
            </lilu-link>
          ) : null}
        </div>
      </div>
    );

    const content = (
      <div class="disturber" style={this.backgroundcolor ? this.renderBackgroundColor() : null}>
        <span class="headline" style={this.textcolor ? this.renderTextColor() : null}>
          {this.headline}
        </span>
        {this.linktext ? (
          <lilu-link appearance="underline" color="dark" colorcode={this.textcolor} link={this.linkhref} target="_self" size="size-14 lg-size-16">
            {this.linktext}
          </lilu-link>
        ) : null}
        <div class="close-button" onClick={e => this.handleDisturber(e)}>
          <lilu-icon color="nero" type="icon-closed-01"></lilu-icon>
        </div>
      </div>
    );

    if (this.isActive) {
      return (
        <Host>
          {this.type === 'wishlist' ? (
            <Fragment>{this.linkhref ? <a href={this.linkhref}>{contentWishlist}</a> : contentWishlist}</Fragment>
          ) : (
            <Fragment>{this.linkhref ? <a href={this.linkhref}>{content}</a> : content}</Fragment>
          )}
        </Host>
      );
    } else {
      return null;
    }
  }
}
